<template>
    <div class="analysis-search-basic">
        <el-form
            label-width="130px"
            size="mini">
            <!-- 选择展示项 -->
            <el-form-item
                :label="$t('message.csales.form1')">
                <el-checkbox 
                    :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">
                    {{$t("message.csales.checkAll")}}
                </el-checkbox>
                <el-checkbox-group
                    v-model="checkedLabel"
                    @change="handleCheckGroupChange"
                    class="analysis-search-basic-options">
                    <el-checkbox 
                        v-for="item in options" 
                        :label="item.label" 
                        :key="item.id">
                        {{item.value}}
                    </el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <!-- 时间选择 -->
            <el-form-item
                :label="$t('message.csales.form2')">
                <!-- 开始时间 -->
                <el-date-picker
                    v-model="form.start_date"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    @change="handleStart"
                    :placeholder="$t('message.csales.place1')"
                    :disabled="!checkedLabel.includes('time')">
                </el-date-picker>
                <span style="margin: 0 5px;">-</span>
                <!-- 结束时间 -->
                <el-date-picker
                    v-model="form.end_date"
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    :placeholder="$t('message.csales.place2')"
                    :disabled="!checkedLabel.includes('time')">
                </el-date-picker>
            </el-form-item>
            <!-- 选择子公司/分行 -->
            <el-form-item
                :label="$t('message.csales.form3')">
                <el-select 
                    v-model="form.branch_id"
                    :placeholder="$t('message.csales.place4')"
                    class="analysis-search-select"
                    clearable
                    @change="handleBranch"
                    :disabled="!checkedLabel.includes('branch')">
                    <el-option
                        v-for="(item, index) in parent_company"
                        :key="index"
                        :label="item.branchname"
                        :value="item.branch_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- 选择部门 -->
            <el-form-item
                :label="$t('message.csales.form4')">
                <el-select 
                    v-model="form.department_id"
                    :placeholder="$t('message.csales.place5')"
                    class="analysis-search-select"
                    clearable
                    @change="handleDepartment"
                    :disabled="!checkedLabel.includes('department')">
                    <el-option
                        v-for="(item, index) in department_options"
                        :key="index"
                        :label="item.departmentname"
                        :value="item.department_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- 选择人员 -->
            <el-form-item
                :label="$t('message.csales.form5')">
                <el-select 
                    v-model="form.user_id"
                    :placeholder="$t('message.csales.place6')"
                    class="analysis-search-select"
                    clearable
                    :disabled="!checkedLabel.includes('member')">
                    <el-option
                        v-for="(item, index) in user_list"
                        :key="index"
                        :label="item.user_id"
                        :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- 订单 -->
            <el-form-item
                :label="$t('message.csales.form6')">
                <el-select 
                    v-model="form.order_sn"
                    class="analysis-search-select"
                    clearable
                    :disabled="!checkedLabel.includes('order')">
                    <el-option
                        v-for="(item, index) in order_op"
                        :key="index"
                        :label="item.order_sn"
                        :value="item.order_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- 选择商品 -->
            <el-form-item
                :label="$t('message.csales.form7')">
                <el-select 
                    v-model="form.selection_goods"
                    :placeholder="$t('message.csales.place3')"
                    class="analysis-search-select"
                    multiple
                    clearable
                    :disabled="!checkedLabel.includes('goods')">
                    <el-option
                        v-for="(item, index) in goods_options"
                        :key="index"
                        :label="item.goods_name"
                        :value="item.goods_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- 品牌 -->
            <el-form-item
                :label="$t('message.csales.form8')">
                <el-select 
                    v-model="form.brand_id"
                    class="analysis-search-select"
                    clearable
                    :disabled="!checkedLabel.includes('brand')">
                    <el-option
                        v-for="(item, index) in brand_op"
                        :key="index"
                        :label="item.brand_name"
                        :value="item.brand_id">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- 行业 -->
            <el-form-item
                :label="$t('message.csales.form9')">
                <el-select 
                    v-model="form.industry"
                    class="analysis-search-select"
                    clearable
                    :disabled="!checkedLabel.includes('industry_price') && !checkedLabel.includes('industry_number')">
                    <el-option
                        v-for="(item, index) in industry_options.industry"
                        :key="index"
                        :label="item"
                        :value="item">
                    </el-option>
                </el-select>
            </el-form-item>
            <!-- 按钮 -->
            <el-form-item>
                <el-button
                    type="primary"
                    @click="handleGetAnalysisData(form)">
                    {{$t("message.csales.btn1")}}
                </el-button>
                <!-- <el-button>
                    查看图表
                </el-button> -->
                <el-button
                    type="primary"
                    @click="handleDownload(form)">
                    {{$t("message.csales.btn2")}}
                </el-button>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { analysis_options } from "../../utils/analysis.js";
import region from '@/utils/region';

const exhibits = () => {
    let list = [];
    for (let item of analysis_options) {
        list.push(item.label)
    }
    return list
}

export default {
    data() {
        return {
            checkAll: false,
            isIndeterminate: true,
            options: analysis_options,
            checkedLabel: [ "time", "branch", "department", "member", "order" ],
            form: {
                start_date: "",
                end_date: "",
                branch_id: "",
                department_id: "",
                user_id: "",
                order_sn: "",
                selection_goods: [],
                brand_id: "",
                industry: ""
            },
            
            pickerOptions: {
                disabledDate:(time)=>{
                    return time.getTime() < new Date(this.form.start_date).getTime();
                }
            },

            user_list: [], // 成员列表
        }
    },
    computed: mapState({
        parent_company: state => state.user.parent_company,
        department_options: state => state.user.analysis.department_options,
        order_op: state => state.user.analysis.order_op,
        goods_options: state => state.user.analysis.goods_options,
        brand_op: state => state.user.analysis.brand_op,
        industry_options(){
            let lang = localStorage.lang,
            industry = region.cn_type;
            if(lang == "en"){
                industry = region.en_type;
            }
            return {
                industry
            }
        }
    }),
    methods: {
        ...mapActions([
            "getAnalysisDepartment",
            "getAnalysis",
            "downloadAnalysis"
        ]),
        handleCheckAllChange(val){ // 展示项全选框
            this.checkedLabel = val ? exhibits() : [];
            this.isIndeterminate = false;
        },
        handleCheckGroupChange(val){ // 展示项组选择框
            let checkedCount = val.length;
            this.checkAll = checkedCount === this.options.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.options.length;
        },
        handleStart(val){ // 开始日期
            if(this.form.end_date < val){
                this.form.end_date=""
            }
        },
        handleBranch(val){ // 分公司
            this.form.department_id = "";
            this.user_list = [];
            this.form.user_id = "";
            this.getAnalysisDepartment(val);
        },
        handleDepartment(val){ // 部门
            this.user_list = [];
            this.form.user_id = "";
            this.department_options.find((item, index, arr) => {
                if(item.department_id === val) this.user_list = item.user;
            })
        },
        handleRow(list){ // 处理提交展示项参数
            return  {
                date: list.includes("time")? 1: 0,
                branch: list.includes("branch")? 1: 0,
                department: list.includes("department")? 1: 0,
                user: list.includes("member")? 1: 0,
                order: list.includes("order")? 1: 0,
                goods: list.includes("goods")? 1: 0,
                goods_sn: list.includes("sn")? 1: 0,
                goods_number: list.includes("num")? 1: 0,
                shop_price: list.includes("unit_price")? 1: 0,
                average_price: list.includes("average_price")? 1: 0,
                brand: list.includes("brand")? 1: 0,
                area: list.includes("area")? 1: 0,
                goods_desc: list.includes("describe")? 1: 0,
                industry_price: list.includes("industry_price")? 1: 0,
                industry_number: list.includes("industry_number")? 1: 0,
                Macao_price: list.includes("Macao_price")? 1: 0,
                Macao_number: list.includes("Macao_number")? 1: 0
            }
        },
        handleGetAnalysisData(form){ // 查询原始表格按钮
            if(this.checkedLabel.length == 0){
                this.$message({
                    showClose: true,
                    message: this.$t("message.csales.error1"),
                    type: "warning"
                })
                return;
            }
            this.$emit('handle-search', {
                row: this.handleRow(this.checkedLabel),
                start: form.start_date, 
                end: form.end_date, 
                user: form.user_id, 
                branch: form.branch_id, 
                department: form.department_id, 
                order_id: form.order_sn, 
                goods_id: form.selection_goods, 
                brand: form.brand_id,
                industry: form.industry
            }, this.checkedLabel)
        },
        handleDownload(form){ // 下载表格
            if(this.checkedLabel.length == 0){
                this.$message({
                    showClose: true,
                    message: this.$t("message.csales.error1"),
                    type: "warning"
                })
                return;
            }
            this.downloadAnalysis({
                row: this.handleRow(this.checkedLabel),
                start: form.start_date, 
                end: form.end_date, 
                user: form.user_id, 
                branch: form.branch_id, 
                department: form.department_id, 
                order_id: form.order_sn, 
                goods_id: form.selection_goods, 
                brand: form.brand_id,
                industry: form.industry
            }).then((res) => {
                window.open(res)
            });
        }
    },
}
</script>

<style scoped>
/* 多选框组样式 */
.analysis-search-basic-options>>>.el-checkbox+.el-checkbox{
    margin-left: 0;
}
/* 选项框 */
.analysis-search-select{
    width: 220px;
}
/* 选择商品-内容样式 */
.analysis-search-select>>>.el-select__tags-text{
    display: inline-block;
    vertical-align: middle;
    width: 155px;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>